import { MarkAsNotSpam, PermanentlyDelete } from './BulkActions'
import {
  createAuthorColumn,
  createPostColumn,
  createPublishDateColumnForSpam,
  createPublishedInColumnForContent
} from './Columns'
import { getSpamContent } from './service'
/* eslint-disable import/no-internal-modules */
import Overview from '@insided/deprecated-control/overview'
import EmptyPage from '@insided/deprecated-preact-components/empty-page/EmptyPage'
import globals from '@insided/deprecated-utils/globals'

const SpamOverview = () => {
  const COLUMNS = [
    createPostColumn(),
    createPublishedInColumnForContent(),
    createAuthorColumn(),
    createPublishDateColumnForSpam()
  ]
  const BULK_ACTIONS = [MarkAsNotSpam, PermanentlyDelete]

  return (
    <Overview
      type='spam'
      headerTitle='Spam'
      withPagination={{
        page: 1,
        pageSize: 25
      }}
      rowId='key'
      model={COLUMNS}
      dataSource={getSpamContent}
      entity='posts'
      bulkActions={BULK_ACTIONS}
      EmptyStateComponent={
        <EmptyPage
          img_src={`${globals('basePath')}images/empty_spam.png`}
          header='All good!'
          text='Nice and clean, there is no spam.'
          button={{ link: '/overview', text: 'Go back to overview' }}
        />
      }
    />
  )
}

export default SpamOverview
